export const compareStringsByAlphabetThenASCII = (
  stringA: string,
  stringB: string
): number => {
  const firstLetterA = stringA.charAt(0);
  const firstLetterB = stringB.charAt(0);
  if (firstLetterA.toLowerCase() < firstLetterB.toLowerCase()) {
    return -1;
  } else if (firstLetterA.toLowerCase() > firstLetterB.toLowerCase()) {
    return 1;
  } else {
    if (firstLetterA.charCodeAt(0) < firstLetterB.charCodeAt(0)) {
      return -1;
    } else if (firstLetterA.charCodeAt(0) > firstLetterB.charCodeAt(0)) {
      return 1;
    } else {
      return stringA.toLowerCase().localeCompare(stringB.toLowerCase());
    }
  }
};
